//Common
import { CAMPO_CONTRATO } from "@/common/constantes";
import { fn_getSituacaoContrato } from "@/common/siig";
import { fn_getMesAnoData } from "@/common/utils/date";

export default class Contrato {
  constructor(dadosContrato = [], situacaoContrato) {
    this.dados = {};

    for (const solContrato of dadosContrato) {
      const campo = solContrato.campo_contrato;

      this.dados[campo.nome] = {
        label: campo.label,
        id_sol_contrato: solContrato.id,
        valor: solContrato.valor,
        descricao_valor: solContrato.descricao_valor,
        descricao: solContrato.descricao_valor || solContrato.valor,
      };
    }

    //Acrescenta a inf. da situação do contrato que foi colocada na tabela solicitacao para facilitar filtros
    const descSituacao = fn_getSituacaoContrato(situacaoContrato).label;
    this.dados["situacao"] = {
      label: "Situação",
      valor: situacaoContrato,
      descricao: descSituacao,
    };
  }

  getDados() {
    return this.dados;
  }

  getCampo(campo) {
    return this.dados[campo.nome];
  }

  getIdSolContrato(campo) {
    return this.dados[campo.nome]?.id_sol_contrato;
  }

  getValor(campo) {
    return this.dados[campo.nome]?.valor;
  }

  getDescricao(campo) {
    return this.dados[campo.nome]?.descricao;
  }

  //GET DOS VALORES e DESCRICOES DOS VALORES DOS CAMPOS
  //CAMPO NUMERO
  get numero() {
    return this.getValor(CAMPO_CONTRATO.NUMERO);
  }

  //CAMPO ACORDO
  get acordo() {
    return this.getValor(CAMPO_CONTRATO.ACORDO) || "N";
  }
  get acordo_desc() {
    return this.getDescricao(CAMPO_CONTRATO.ACORDO) || "Não";
  }

  //CAMPO TIPO RENOVACAO
  get tipo_renovacao() {
    return this.getValor(CAMPO_CONTRATO.TIPO_RENOVACAO);
  }
  get tipo_renovacao_desc() {
    return this.getDescricao(CAMPO_CONTRATO.TIPO_RENOVACAO);
  }

  //CAMPO TIPO PERIODICIDADE
  get tipo_periodicidade() {
    return this.getValor(CAMPO_CONTRATO.TIPO_PERIODICIDADE);
  }
  get tipo_periodicidade_intervalo() {
    return this.getValor(CAMPO_CONTRATO.TIPO_PERIODICIDADE_INTERVALO);
  }
  get tipo_periodicidade_mes() {
    return this.getValor(CAMPO_CONTRATO.TIPO_PERIODICIDADE_MES);
  }
  get tipo_periodicidade_mes_desc() {
    return this.getDescricao(CAMPO_CONTRATO.TIPO_PERIODICIDADE_MES);
  }

  //CAMPO INDICE REAJUSTE
  get indice_reajuste() {
    return this.getValor(CAMPO_CONTRATO.INDICE_REAJUSTE);
  }
  get indice_reajuste_desc() {
    return this.getDescricao(CAMPO_CONTRATO.INDICE_REAJUSTE);
  }

  //CAMPO VIGENCIA
  get vigencia() {
    return this.getValor(CAMPO_CONTRATO.PERIODO_VIGENCIA);
  }

  //CAMPO SITUACAO
  get situacao() {
    return this.dados["situacao"].valor; //this.getValor(CAMPO_CONTRATO.SITUACAO);
  }
  get situacao_desc() {
    return this.dados["situacao"].descricao; //this.getDescricao(CAMPO_CONTRATO.SITUACAO);
  }
  // get situacao_id_sol_contrato() {
  //   return this.getIdSolContrato(CAMPO_CONTRATO.SITUACAO);
  // }

  //### FUNCOES ###
  //Verifica se o contrato é reajustável
  isReajustavel() {
    const indiceReajuste = this.getValor(CAMPO_CONTRATO.INDICE_REAJUSTE);
    return indiceReajuste != null && indiceReajuste != "0";
  }

  //Retorna a data início da vigência do contrato no formato DD/MM/YYYY
  getDataInicioVigencia() {
    const [dataInicio] = this.getValor(CAMPO_CONTRATO.PERIODO_VIGENCIA).split(
      " - ",
    );

    return dataInicio.trim();
  }

  //Retorna o mes/ano início da vigência do contrato no formato MM/YYYY
  getMesAnoInicioVigencia() {
    return fn_getMesAnoData(this.getDataInicioVigencia());
  }

  //Retorna a data fim da vigência do contrato no formato DD/MM/YYYY
  getDataFimVigencia() {
    const [, dataFim] = this.getValor(CAMPO_CONTRATO.PERIODO_VIGENCIA).split(
      " - ",
    );
    return dataFim.trim();
  }

  //Retorna o mes/ano início da vigência do contrato no formato MM/YYYY
  getMesAnoFimVigencia() {
    return fn_getMesAnoData(this.getDataFimVigencia());
  }
}
